module.exports = __webpack_public_path__ + "img/icon-twitter.2db9c761.svg";